import { API_URL, apiClient } from '@/lib/api';
import { getAccessToken } from '@/lib/authStorage';

// Комментарий на русском: общий fetch-обёртка для мессенджера.
// Зачем: в одном месте держим добавление Bearer-токена и тихий refresh при 401.
export async function apiCall(url: string, options: RequestInit = {}) {
  const doFetch = async () => {
    const token = getAccessToken() || '';
    const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;

    const headers: Record<string, string> = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    if (!isFormData && !(options.headers as any)?.['Content-Type']) {
      headers['Content-Type'] = 'application/json';
    }

    // Комментарий на русском: мессенджер должен быть всегда актуальным.
    // Зачем: браузерный HTTP-кэш иногда “залипает” на списках/лентах, и данные обновляются только после очистки кэша.
    const cache = (options as any)?.cache ?? 'no-store';

    return fetch(`${API_URL}${url}`, {
      ...options,
      cache,
      headers: {
        ...headers,
        ...(options.headers as Record<string, string> | undefined),
      },
    });
  };

  let res = await doFetch();
  if (res.status === 401) {
    const refreshed = await apiClient.refreshToken();
    if (refreshed) res = await doFetch();
  }
  return res;
}


